import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User creates a new library',
  name: 'created_library',
  params: [
    {
      description: 'The name of the library',
      name: 'library_name',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
